import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=6f89182d&scoped=true"
import script from "./badge.vue?vue&type=script&lang=js"
export * from "./badge.vue?vue&type=script&lang=js"
import style0 from "./badge.vue?vue&type=style&index=0&id=6f89182d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89182d",
  null
  
)

export default component.exports